<template>
  <div>
    <template v-if="version === 'v1'">
      <router-link class="no-underline" :to="route">
        <div
          class="shadow-custom capitalize rounded-lg py-8 px-5 text-center text-black transition hover:text-white hover:bg-accent">
          {{ title }}
        </div>
      </router-link>
    </template>
    <template v-else>
      <a :href="externalLink" class="no-underline">
        <div
          class="shadow-custom capitalize rounded-lg py-8 px-5 text-center text-black transition hover:text-white hover:bg-accent">
          {{ title }}
        </div>
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: "menu-grid-item",
  props: {
    route: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: 'v1'
    }
  },
  computed: {
    externalLink() {
      const VUE_APP_BACKOFFICE_DOMAIN = process.env.VUE_APP_BACKOFFICE_DOMAIN;
      return `${VUE_APP_BACKOFFICE_DOMAIN}${this.route}`
    }
  }
}
</script>
<style scoped>
.shadow-custom {
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .1);
}

.shadow-custom:hover {
  font-size: 16px;
  transition: font-size 300ms;
}
</style>